import { cn } from "@/lib/utils";

/** Responsive data table with the official navy header style. */
export function DataTable({ columns, rows, testId, className }) {
  return (
    <div
      data-testid={testId}
      className={cn(
        "border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm overflow-x-auto",
        className
      )}
    >
      <table className="w-full min-w-[700px] border-collapse">
        {columns && (
          <thead>
            <tr className="bg-slate-900 text-white">
              {columns.map((c) => (
                <th
                  key={c}
                  className="px-5 py-3.5 text-left text-xs font-bold uppercase tracking-wider text-slate-100"
                >
                  {c}
                </th>
              ))}
            </tr>
          </thead>
        )}

        <tbody>
          {rows.map((row, i) => {
            // Support both old array format and new object format
            const isObject = !Array.isArray(row);

            const section = isObject ? row.section : row[0];
            const topics = isObject ? row.topics : null;
            const questions = isObject ? row.questions : row[1];
            const weightage = isObject ? row.weightage : row[2];
            const duration = isObject ? row.duration : row[3];

            return (
              <tr
                key={i}
                className={i % 2 === 1 ? "bg-slate-50/70" : "bg-white"}
              >
                {/* Section */}
                <td className="px-5 py-4 text-sm border-b border-slate-100 align-top">
                  <div className="font-semibold text-slate-900">
                    {section}
                  </div>

                  {Array.isArray(topics) && topics.length > 0 && (
                    <ul className="mt-2.5 space-y-1.5 text-sm font-normal text-slate-500">
                      {topics.map((topic, index) => (
                        <li key={index} className="flex gap-2">
                          <span className="shrink-0 text-slate-400">
                            •
                          </span>

                          <span>{topic}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </td>

                {/* Questions */}
                <td className="px-5 py-4 text-sm text-slate-600 border-b border-slate-100 align-top">
                  {questions}
                </td>

                {/* Weightage */}
                <td className="px-5 py-4 text-sm text-slate-600 border-b border-slate-100 align-top">
                  {weightage}
                </td>

                {/* Duration */}
                <td className="px-5 py-4 text-sm text-slate-600 border-b border-slate-100 align-top">
                  {duration}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}